import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedGuard } from '@x/guard/logged.guard';
import { NotLoggedGuard } from '@x/guard/not-logged.guard';

const routes: Routes = [
  // Auth
  {
    path: 'auth',
    canActivate: [NotLoggedGuard],
    loadChildren: () => import('./children/auth/auth.module').then((m) => m.AuthModule),
  },
  // Upload
  {
    path: '',
    canActivate: [LoggedGuard],
    loadChildren: () => import('./children/upload/upload-routing.module').then((m) => m.UploadRoutingModule),
  },
  // Wild card
  {
    path: '**',
    redirectTo: 'auth',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
